import React, { useRef, useState } from 'react';
import Calendar from 'react-calendar';
import { format } from 'date-fns';
import { useOnClickOutside } from '../../../hooks';
import { IconSVG } from '../../IconSVG';
import './DatePicker.scss';
import { datePickerCss } from '../utils';
export const DatePicker = ({ labelText = '', className, overrideCssClass, value, alignByRightCorner = false, onChange, tileDisabled, disabled = false, }) => {
    const [isOpen, setOpen] = useState(false);
    const ref = useRef(null);
    const { datePicker, datePickerSelectionBox, datePickerCalendar, datePickerLabel, datePickerIcon, datePickerSelectedDate, } = datePickerCss({
        className,
        overrideCssClass,
        isOpen,
        alignByRightCorner,
        disabled,
    });
    useOnClickOutside(ref, () => setOpen(false));
    const handleClick = () => {
        if (!disabled) {
            setOpen(!isOpen);
        }
    };
    const handleChange = (date) => {
        if (!disabled) {
            setOpen(false);
            if (onChange) {
                onChange(date);
            }
        }
    };
    return (React.createElement("div", { className: datePicker, ref: ref },
        React.createElement("button", { type: "button", className: datePickerSelectionBox, onClick: handleClick },
            labelText && React.createElement("div", { className: datePickerLabel }, labelText),
            React.createElement("div", { className: datePickerSelectedDate }, format(value, 'dd-MMM-yyyy')),
            !disabled && (React.createElement("div", { className: datePickerIcon },
                React.createElement(IconSVG, { iconType: "Calendar" })))),
        isOpen && (React.createElement("div", { className: datePickerCalendar },
            React.createElement(Calendar, { onChange: handleChange, value: value, tileDisabled: tileDisabled })))));
};
//# sourceMappingURL=DatePicker.js.map